import AuthButtonComponent from "./AuthButtonComponent";

export default AuthButtonComponent;
